/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsEntityType {
    __type: string;

    protected setDiscriminator(type: string) {
        this.__type = type;
    }

    constructor() {
        this.setDiscriminator("AppSecopsEntityType");
    }

    getFixupPrototypeFunction() { return AppSecopsEntityType.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsEntityType>): AppSecopsEntityType {
        let obj = Object.assign(new AppSecopsEntityType(), model);
        AppSecopsEntityType.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsEntityType>): AppSecopsEntityType {
        if (!model) return null;
        return AppSecopsEntityType.newInstance(<AppSecopsEntityType> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsEntityType) {
        if (!obj) return;

        models.AppSecopsEntityType.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsEntityType): boolean {
        switch (obj.__type)
        {
            case "AppSecopsEntityType":
                Object.setPrototypeOf(obj, AppSecopsEntityType.prototype);
                break;
            case "AppSecopsEntityTypeForApplicationChange":
                Object.setPrototypeOf(obj, models.AppSecopsEntityTypeForApplicationChange.prototype);
                break;
            case "AppSecopsEntityTypeForProjectChange":
                Object.setPrototypeOf(obj, models.AppSecopsEntityTypeForProjectChange.prototype);
                break;
        }
        return true; // Tell the caller this is a polymorphic type, it should not overwrite the prototype.
    }

    static getTypeHierarchy(): (typeof AppSecopsEntityType)[] {
        return [
            models.AppSecopsEntityTypeForApplicationChange,
            models.AppSecopsEntityTypeForProjectChange,
        ];
    }

    fixupFields() {
    }

}
